import { render } from "./TopBrandsTableCard.vue?vue&type=template&id=66a6d12d"
import script from "./TopBrandsTableCard.vue?vue&type=script&lang=js"
export * from "./TopBrandsTableCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TopBrandsTableCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66a6d12d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66a6d12d', __exports__)) {
    console.log('reload')
    api.reload('66a6d12d', __exports__)
  }
  
  module.hot.accept("./TopBrandsTableCard.vue?vue&type=template&id=66a6d12d", () => {
    console.log('re-render')
    api.rerender('66a6d12d', render)
  })

}


export default __exports__